//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        appName: '',
        keyId: '',
        dateFrom: '',
        dateTo: '',
      },
    };
  },

  computed: {
    ...mapState('userApiKeys', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
    const keyId = this.$route.query.keysKeyId;

    if (keyId) {
      this.$router.replace({ query: {} });
    }
    this.filters = {
      ...this.filters,
      keyId,
    };
  },

  methods: {
    ...mapActions('userApiKeys', ['setFilters']),
  },
};
